import createHistory from 'history/createBrowserHistory';

export default createHistory({
    forceRefresh: true
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/auth/History.ts